export default {
      id: "save-usage",
      viewBox: "0 0 27.862 27.862",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#save",
      toString: function () {
        return this.url;
      }
    }